import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../../actions/actionCreators';
import UserNavBar from '../UserNav/UserNav';

class UserApp extends React.Component {
    render() {
        return (
            <div className="UserApp">
                <UserNavBar />
                {/*{this.props.children}*/}
                {React.cloneElement(this.props.children, this.props)}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.users,
        currentUser: state.currentUser,
        requests: state.requests.filter((request) => {
            return request.requestInfo.userId === state.currentUser.userId;
        }),
        permissions: state.permissions
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserApp);



/** WEBPACK FOOTER **
 ** ./src/components/User/UserApp/UserApp.js
 **/